<div class="admin-stations">

  <sc-master-detail [selection]="[selectedStation]" [data]="stations" [newStyle]="true"
    (selectionChanged)="onSelectionChanged($event);" (addEntry)="onAddEntry($event);"
    (deleteEntry)="onDeleteEntry($event);">

    <div class="details-layout">
      <form #stationForm="ngForm" class="details-form">
        <ng-container *ngIf="selectedStation">
          <app-station-details [station]="workingCopyDetails" [form]="stationForm">
          </app-station-details>
        </ng-container>
      </form>
    </div>

    <ng-template masterDetailToolbar>
      <button mat-stroked-button [disabled]="!cancelEnabled" (click)="cancel()">{{'cancel' | translate:
        ['tmc.admin.stations.cancel',
        translationService.language]}}</button>
      <sc-content-spacer></sc-content-spacer>
      <button mat-flat-button (click)="save()" [disabled]="!saveEnabled">{{'save' | translate:
        ['tmc.admin.stations.save', translationService.language]}}</button>
    </ng-template>

  </sc-master-detail>

</div>